import { DriverSalaryAdjustmentsDetail, DriverSalaryAdjustmentsDetailRequest, DriverSalaryAdjustmentsInfoItem, DriverSalaryAdjustmentsItem } from "./types";
import { createActionTypes, createApiActions } from "../rootActions";
import { PayloadRequest } from "types/requestTypes";


export const driverSalaryAdjustmentsDetail = createApiActions<PayloadRequest, DriverSalaryAdjustmentsItem>(
    createActionTypes("driverSalaryAdjustments_detail")
);
export const driverSalaryAdjustmentsCreate = createApiActions<DriverSalaryAdjustmentsItem, void>(
    createActionTypes("driverSalaryAdjustments_create")
);
export const driverSalaryAdjustmentsEdit = createApiActions<DriverSalaryAdjustmentsItem, void>(
    createActionTypes("driverSalaryAdjustments_edit")
);
export const driverSalaryAdjustmentsDelete = createApiActions<PayloadRequest, void>(
    createActionTypes("driverSalaryAdjustments_delete")
);
export const driverSalaryAdjustmentsInfo = createApiActions<PayloadRequest, DriverSalaryAdjustmentsInfoItem>(
    createActionTypes("driverSalaryAdjustments_info")
);

///detail
export const driverSalaryAdjustmentsDetailOne = createApiActions<PayloadRequest, DriverSalaryAdjustmentsDetail>(
    createActionTypes("driverSalaryAdjustmentsDetail_one")
);
export const driverSalaryAdjustmentsDetailList = createApiActions<PayloadRequest, DriverSalaryAdjustmentsDetail[]>(
    createActionTypes("driverSalaryAdjustmentsDetail_list")
);
export const driverSalaryAdjustmentsDetailCreate = createApiActions<DriverSalaryAdjustmentsDetailRequest, void>(
    createActionTypes("driverSalaryAdjustmentsDetail_create")
);
export const driverSalaryAdjustmentsDetailEdit = createApiActions<DriverSalaryAdjustmentsDetailRequest, void>(
    createActionTypes("driverSalaryAdjustmentsDetail_edit")
);
export const driverSalaryAdjustmentsDetailDelete = createApiActions<PayloadRequest, void>(
    createActionTypes("driverSalaryAdjustmentsDetail_delete")
);
